import React, { useState } from 'react'

import Card from 'react-bulma-components/lib/components/card'
import CardHeader from 'react-bulma-components/lib/components/card/components/header'
import CardHeaderTitle from 'react-bulma-components/lib/components/card/components/header/components/header-title'
import CardHeaderIcon from 'react-bulma-components/lib/components/card/components/header/components/header-icon'
import CardContent from 'react-bulma-components/lib/components/card/components/content'
import CardFooter from 'react-bulma-components/lib/components/card/components/footer'
import Button from 'react-bulma-components/lib/components/button'
import Icon from 'react-bulma-components/lib/components/icon'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfo, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'

import Slider from '../slider'
import InfoPanel from './InfoPanel'
import MultiRegion from './MultiRegion'

const InfoIcon = ({ onClick }) => <CardHeaderIcon onClick={onClick} className='options-header-icon'>
  <FontAwesomeIcon icon={faInfo} />
</CardHeaderIcon>

const ModalIcon = () => <Icon>
  <FontAwesomeIcon icon={faMapMarkerAlt} />
</Icon>

const OptionsContent = ({ options, selected, select, open }) => <CardContent className='options-content'>
  <div className='options-buttons'>
    {options.map((props) => {
      const { key, label, description, multiRegion } = props
      return <Button
        className={selected === key ? 'is-selected' : 'is-default'}
        onClick={() => {
          if (multiRegion) open(props)
          else select({ id: key, label })
        }}
        key={key}
        title={description}
        fullwidth>
        {multiRegion ? <ModalIcon /> : null}
        <span>{label}</span>
      </Button>
    }
    )}
  </div>
</CardContent>

const OptionsSlider = ({ value, handle }) => <CardFooter>
  <Slider
    value={value}
    handle={value => handle(Number(value))}
  />
</CardFooter>

export default ({
  title,
  info = '',
  options = [],
  selected,
  select,
  slider,
  value,
  handle
}) => {
  const [infoActive, setInfoActive] = useState(false)
  const [modalActive, setModalActive] = useState(false)
  const [modalParent, setModalParent] = useState({})

  return <>
    <MultiRegion
      parent={modalParent}
      active={modalActive}
      select={select}
      close={() => {
        setModalParent({})
        setModalActive(false)
      }} />
    <div className='options'>
      {info && infoActive ? <InfoPanel title={title} info={info} close={() => setInfoActive(false)} /> : null}
      <Card>
        <CardHeader className='options-header'>
          <CardHeaderTitle>{title}</CardHeaderTitle>
          {info ? <InfoIcon onClick={() => setInfoActive(true)} /> : null}
        </CardHeader>
        <OptionsContent options={options} selected={selected} select={select} open={(parent) => {
          setModalParent(parent)
          setModalActive(true)
        }} />
        {slider ? <OptionsSlider value={value} handle={handle} /> : null}
      </Card>
    </div>
  </>
}
